export const AppFooter = defineAsyncComponent(
  () => import('@/widgets/Footer/ui/@platform/index.vue'),
);
